module.exports = __webpack_public_path__ + "img/icon_benefits_02.bb9b4e7c.jpg";